import React from "react";
import "./tag.sass";
import classNames from "classnames";
import Spinner from "../common/spinner/spinner";

export type TagType =
  | "digital"
  | "system"
  | "success"
  | "warning"
  | "negative"
  | "neutral"
  | "light"
  | "disabled";

export interface ITagsProps {
  text?: string;
  children?: React.ReactNode;
  type?: TagType;
  isBusy?: boolean;
  isMuted?: boolean;
  className?: string;
}

const Tag: React.FC<ITagsProps> = ({
  text,
  type,
  children,
  isBusy = false,
  className
}) => {
  const body = children ?? text;

  return (
    <span
      className={classNames(
        "tag",
        {
          "digital-tag": type === "digital",
          "system-tag": type === "system",
          "success-tag": type === "success",
          "warning-tag": type === "warning",
          "negative-tag": type === "negative",
          "neutral-tag": type === "neutral",
          "light-tag": type === "light",
          "disabled-tag": type === "disabled",
          busy: isBusy
        },
        className
      )}
    >
      {isBusy ? <Spinner large={false} /> : body}
    </span>
  );
};

export default Tag;
